<div class="container-fluid d-flex p-0 position-relative">
  <!-- LEFT PANEL: show from md and up -->
  <div class="col-6 col-md-6 d-none d-md-flex bg-warning text-white login-panel-left">
    <div class="d-flex flex-column justify-content-center align-items-center vh-100 w-100 px-5">
      <div class="absolute-top-left">
        <router-link
          to="/"
          class="auth-logo mb-2 text-decoration-none d-inline-block"
          aria-label="NPI Home"
        ></router-link>
      </div>

      <h3 class="fw-bold mb-4 text-dark">
        Manage Your B-BBEE Compliance with Confidence
      </h3>
      <p class="text-dark text-sm">
        Track programmes, prepare audit packs, and achieve your target BEE level with our comprehensive platform.
      </p>
    </div>
  </div>

  <!-- RIGHT PANEL: full width on mobile, half on md+ -->
  <div class="col-12 col-md-6 d-flex align-items-center justify-content-center vh-100 flex-column">
    <div class="p-4 p-md-5 login-panel">
      <div class="w-100 mb-3">
        <button
          type="button"
          class="btn btn-link text-white-50 p-0 back-home text-gray text-xs"
          @click="go_home"
        >
          &larr; Back to home
        </button>
      </div>

      <h3 class="fw-bold mb-1 text-white">Welcome Back</h3>

      <p class="text-white-50 mb-4 text-xs">
        Enter your credentials to access your dashboard.
      </p>

      <div
        v-if="error_message"
        class="alert alert-danger alert-dismissible fade show rounded-3"
        role="alert"
      >
        {{ error_message }}
        <button type="button" class="btn-close" @click="error_message = ''"></button>
      </div>

      <div v-if="is_loading" class="text-center mb-3">
        <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
        <span class="text-white-50">Authenticating...</span>
      </div>

      <form @submit.prevent="handle_login" v-if="!is_loading">
        <div class="mb-3">
          <label class="form-label text-xs text-white-50">Email</label>
          <input
            v-model="credentials.email"
            type="email"
            class="form-control form-control-sm rounded-3 bg-transparent text-white border-secondary placeholder-white"
            placeholder="Enter email"
            required
          />
        </div>

        <div class="mb-3">
          <label class="form-label text-xs text-white-50 mb-1">Password</label>
            <div class="position-relative">
              <input
                v-model="credentials.password"
                :type="password_input_type"
                class="form-control form-control-sm rounded-3 pe-5
                      bg-transparent text-white border-secondary placeholder-white"
                placeholder="Enter password"
                required
              />
              <button
                type="button"
                class="btn position-absolute top-50 end-0 translate-middle-y text-white-50 px-2"
                @click="toggle_change_password_type"
                :aria-label="password_input_type === 'password' ? 'Show password' : 'Hide password'"
              >
                <i :class="password_input_type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </button>
            </div>
        </div>

        <button class="btn btn-primary w-100 rounded-3 fw-light text-xs mb-3" :disabled="is_loading">
          Sign in
        </button>

        <p class="text-center text-white-50 text-xs mb-0">
          Forgot your password?
          <router-link to="/reset_password" class="text-decoration-none text-primary">
            Reset
          </router-link>
        </p>
      </form>
    </div>
  </div>
</div>
